import { useEffect, useState } from "react";

const LETTERS = ["C", "A", "R", "V", "A", "E", "L", "I", "S"];

export default function SplashIntro() {
    const [show, setShow] = useState(true);
    const [hide, setHide] = useState(false);

    useEffect(() => {
        // Only show once per session
        if (sessionStorage.getItem("carvaelis_intro_seen") === "1") {
            setShow(false);
            return;
        }
        // Start fade out after animation completes
        const fadeTimer = setTimeout(() => setHide(true), 2400);
        const removeTimer = setTimeout(() => {
            setShow(false);
            sessionStorage.setItem("carvaelis_intro_seen", "1");
        }, 3100);
        // Prevent scroll during intro
        document.body.style.overflow = "hidden";
        const restoreScroll = setTimeout(() => {
            document.body.style.overflow = "";
        }, 2400);
        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(removeTimer);
            clearTimeout(restoreScroll);
            document.body.style.overflow = "";
        };
    }, []);

    if (!show) return null;

    return (
        <div
            data-testid="splash-intro"
            className={`fixed inset-0 z-[9999] bg-ink flex items-center justify-center transition-opacity duration-700 ${
                hide ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
        >
            {/* Grain overlay */}
            <div
                className="absolute inset-0 opacity-[0.05] pointer-events-none"
                style={{
                    backgroundImage:
                        "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")",
                }}
            />
            {/* Radial glow */}
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(31,111,240,0.15),transparent_60%)]" />

            <div className="relative flex flex-col items-center">
                {/* Tagline top */}
                <p className="splash-tagline text-[10px] sm:text-xs uppercase tracking-[0.4em] text-white/40 mb-10">
                    Nous conduisons la confiance
                </p>

                {/* Letters */}
                <div className="flex items-baseline">
                    {LETTERS.map((L, i) => (
                        <span
                            key={i}
                            className={`splash-letter font-display font-black tracking-tighter text-white ${
                                i >= 6 ? "italic text-signal" : ""
                            } text-6xl sm:text-8xl lg:text-9xl`}
                            style={{
                                animationDelay: `${0.15 + i * 0.08}s`,
                            }}
                        >
                            {L}
                        </span>
                    ))}
                </div>

                {/* Smile that draws itself */}
                <svg
                    className="mt-4 sm:mt-6 splash-smile"
                    viewBox="0 0 340 30"
                    width="280"
                    height="24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8 8 Q 170 44 332 8"
                        stroke="#1F6FF0"
                        strokeWidth="7"
                        strokeLinecap="round"
                        fill="none"
                        pathLength="1"
                    />
                </svg>

                {/* Progress bar */}
                <div className="mt-14 w-40 h-[2px] bg-white/10 overflow-hidden">
                    <div className="splash-progress h-full bg-signal" />
                </div>
            </div>

            <style>{`
                .splash-letter {
                    opacity: 0;
                    transform: translateY(24px);
                    animation: splashLetterIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
                }
                @keyframes splashLetterIn {
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .splash-smile path {
                    stroke-dasharray: 1;
                    stroke-dashoffset: 1;
                    animation: splashSmileDraw 1s ease-out 1.1s forwards;
                }
                @keyframes splashSmileDraw {
                    to {
                        stroke-dashoffset: 0;
                    }
                }
                .splash-progress {
                    width: 0;
                    animation: splashProgress 2.3s linear forwards;
                }
                @keyframes splashProgress {
                    to {
                        width: 100%;
                    }
                }
                .splash-tagline {
                    opacity: 0;
                    animation: splashFade 0.7s ease-out 0.1s forwards;
                }
                @keyframes splashFade {
                    to {
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
}
